import React, { useState, useEffect } from "react";
import BackspaceIcon from "@mui/icons-material/Backspace";
import * as images from "../../Constant/images";
import getFaresIcon from "../../assets/get_fares.png";
import arrangeCallIcon from "../../assets/arrange_a_call.png";
import ArrangeCallModel from "../Commom/ArrangeCallModel";
const ArrangeCall = () => {
  const [isOpened, setOpened] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  // Phones (<=480px) get the call + WhatsApp floats instead of the chat link
  const [showChatLink, setShowChatLink] = useState(window.innerWidth > 480);
  useEffect(() => {
    const onResize = () => setShowChatLink(window.innerWidth > 480);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const handleCloseModel = () => {
    setOpened(false);
  };
  const handleArrangeCall = () => {
    setIsOpen(true);
  };
  return (
    <div className="arrange-call-container">
      {showChatLink && (
        <a
          className="chat-float-btn chat-float-link pump_up_animation"
          href="https://chat.faremakers.com"
          target="_blank"
          rel="noreferrer"
          aria-label="Open Faremakers chat in a new tab"
          title="Chat with Faremakers"
        >
          <img src={getFaresIcon} alt="Open Faremakers chat" />
        </a>
      )}
      {isOpened && (
        <div className="call_btn_bg pump_up_animation ">
          <div
            className="d-flex justify-content-end"
            onClick={handleCloseModel}
          >
            <BackspaceIcon className="call_close_btn" />
          </div>
          <div className="chat-float-btn pump_up_animation">
            <img
              src={arrangeCallIcon}
              alt="Arrange a call"
              onClick={handleArrangeCall}
            />
          </div>
          {/* <button className='btn btn-primary btn_inner_typo pump_up_animation'> Arrange a Call</button> */}
        </div>
      )}
      {isOpen && (
        <ArrangeCallModel
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          setOpened={setOpened}
        />
      )}
    </div>
  );
};

export default ArrangeCall;
